import { AxiosInstanceBase, AxiosInstanceToken } from "services/axios";
import {
  TContactGetTokenResponse,
  TContactSendMailMaterials,
  TContactSendMailResponse,
} from "services/contact/types";

class Contact {
  getToken = async (): Promise<TContactGetTokenResponse> => {
    const response = await AxiosInstanceToken().post(
      "/token",
      "grant_type=client_credentials&scope=PRODUCTION",
      {
        params: { tenantDomain: "carbon.super" },
      }
    );

    return response.data;
  };

  sendMail = async (
    materials: TContactSendMailMaterials
  ): Promise<TContactSendMailResponse> => {
    const body = materials.body;
    body.append("appId", "101D");
    body.append("type", "Contact");

    const response = await AxiosInstanceBase().post(
      "/customer-support-service/1.0.0/requests",
      body,
      {
        headers: {
          authorization: `Bearer ${materials.token}`,
        },
      }
    );
    return response.data;
  };
}

const ContactInstance = new Contact();

export default ContactInstance;
